import React from "react";
import { useLocation } from "react-router-dom";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { map } from "lodash";
import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";
import { push } from "store/actions/router";

import Payrolls from "../employers/Payrolls";
import MissedPayrolls from "../employers/MissedPayrolls";

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = { push };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

// `routeName` is injected by the AdminTransactions_WithLocation wrapper below;
// `client` comes from withApollo, forwarded through {...props}.
interface OwnProps {
  routeName?: string;
  // `error` is declared by the original PropTypes but never read; kept optional
  // to preserve the documented prop surface.
  error?: string;
}

type Props = WithApolloClient<OwnProps> & PropsFromRedux;

interface State {
  tab: string;
}

class AdminTransactions extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      tab: this._calcActiveTab(props.routeName),
    };
  }

  _tabUpdate(value: { k: string }) {
    this.setState({ tab: value.k });
    this.props.push(`/transactions/${value.k}`);
  }

  _getTabs = () => {
    let allTabs = [
      {
        label: "Payrolls",
        id: "payrolls",
      },
      {
        label: "Missed Payrolls",
        id: "missed_payrolls",
      },
    ];

    return allTabs;
  };

  _controlledTabs() {
    const tabs = this._getTabs();
    return (
      <Tabs
        activeKey={this.state.tab}
        id="tab-transaction"
        onSelect={(k) => this._tabUpdate({ k: k as string })}
      >
        {map(tabs, (tab) => {
          return <Tab key={tab.id} eventKey={tab.id} title={tab.label} />;
        })}
      </Tabs>
    );
  }

  _calcActiveTab = (routeName?: string) => {
    switch (routeName) {
      case "/transactions/missed_payrolls":
        return "missed_payrolls";
      default:
        return "payrolls";
    }
  };

  _getCardContent = () => {
    switch (this.state.tab) {
      case "payrolls":
        return <Payrolls />;
      case "missed_payrolls":
        return <MissedPayrolls />;
    }
  };

  render() {
    return (
      <div className="mega-container">
        <section className="page-title-wrap">
          <article className="text-cell">
            <h1 className="page-title">Transactions</h1>
            <div className="main-content">
              <Row>
                <Col>
                  <div className="card-tab">{this._controlledTabs()}</div>
                  <Card>
                    <Card.Body>{this._getCardContent()}</Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </article>
        </section>
      </div>
    );
  }
}

// The location wrapper receives `client` (from withApollo) plus the connected
// `push`, forwards them to the class, and injects `routeName` from the router.
const AdminTransactions_WithLocation = (props: Props) => {
  const { pathname: routeName } = useLocation();
  return <AdminTransactions {...props} routeName={routeName} />;
};

export default connector(withApollo<Props>(AdminTransactions_WithLocation));
